<template>
  <div class="detail-div">
    <CRow>
      <div>
        <CModal :title="submitType === 'Update' ? $lang.candidates.crud.edit : $lang.common.general.reason" size="lg"
                :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
          <CCardBody>
            <CRow>
              <CCol md="12">
                <c-textarea v-model="post.reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
              </CCol>
              <CCol md="6">
                <div class="form-group">
                  <CButton color="primary" v-c-tooltip="$lang.candidates.crud.recruitments_status" :disabled="submitted"
                           v-on:click="blockPost(statusId)">Submit
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
          <template #footer style="display: none">
            <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
            <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
          </template>
        </CModal>
      </div>
      <CCol md="12" class="align-self-center">
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.company }}
            </p>
            <p class="custome-detail">
              <profiler-detail :username="candidateData.company" :profilerId="candidateData.userId"></profiler-detail>
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cFirstName }}
            </p>
            <p class="custome-detail">
              {{ candidateData.cFirstName }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cLastName }}
            </p>
            <p class="custome-detail">
              {{ candidateData.cLastName }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cNickName }}
            </p>
            <p class="custome-detail">
              {{ candidateData.cNickName }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cMobileNo }}
            </p>
            <p class="custome-detail">
              {{ candidateData.cMobileNo }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cEmail }}
            </p>
            <p class="custome-detail">
              {{ candidateData.cEmail }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.jobtype }}
            </p>
            <p class="custome-detail">
              {{ candidateData.jobType }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.title }}
            </p>
            <p class="custome-detail">
              {{ candidateData.title }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.experience }}
            </p>
            <p class="custome-detail">
              {{ experience }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.minSalary }}
            </p>
            <p class="custome-detail">
              {{ candidateData.minSalary }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.maxSalary }}
            </p>
            <p class="custome-detail">
              {{ candidateData.maxSalary }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.workType }}
            </p>
            <p class="custome-detail">
              {{ worktype }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.requirement }}
            </p>
            <p class="custome-detail">
              {{ requirement }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="candidateData.commissionType">
            <p class="custome-labal">
              {{ $lang.candidates.detail.commissionType }}
            </p>
            <p class="custome-detail">
              {{ candidateData.commissionType }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="candidateData.commissionPer">
            <p class="custome-labal">
              {{ $lang.candidates.detail.commission }}
            </p>
            <p class="custome-detail">
              {{ candidateData.commissionPer }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="candidateData.commissionMonth">
            <p class="custome-labal">
              {{ $lang.candidates.detail.commissionMonth }}
            </p>
            <p class="custome-detail">
              {{ candidateData.commissionMonth }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.candidates.detail.status }}</p>
            <p class="custome-detail">
              <CBadge :color="statusBudget(candidateData.status)">{{ candidateData.status }}</CBadge>
            </p>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.jobLocation }}
            </p>
            <p class="custome-detail">
              {{ candidateData.jobLocation }}
            </p>
          </CCol>
          <!--          <CCol sm="6" md="4" lg="4" >-->
          <!--            <p class="custome-labal">-->
          <!--              {{ $lang.candidates.detail.country}}-->
          <!--            </p>-->
          <!--            <p class="custome-detail">-->
          <!--              {{candidateData.country.name}}-->
          <!--            </p>-->
          <!--          </CCol>-->
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.candidates.detail.cities }}
            </p>
            <p class="custome-detail">
               <span v-for="(city, index) in candidateData.cities">
                 <span v-if="index !== 0">, </span><span>{{ city.name }}</span>
              </span>
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="12">
            <p class="custome-labal">
              {{ $lang.candidates.detail.description }}
            </p>
            <p class="custome-detail">
              {{ candidateData.description }}
            </p>
          </CCol>
        </CRow>
        <EntityTimeStamp :createdAt="candidateData.createdAt" :updatedAt="candidateData.updatedAt"
                         :createdBy="candidateData.firstName" :avatar="candidateData.avatar"></EntityTimeStamp>
        <CRow v-show="candidateData.blockedReason">
          <CCol sm="12" align="left">
            <strong>Blocked Reason: </strong> {{ candidateData.blockedReason }}
          </CCol>
        </CRow>
        <CRow v-if="!candidateData.blockedReason && candidateData.isActive!==2">
          <CCol sm="12" align="left">
            <CButton :color="statusColor" v-c-tooltip="statusLabel" v-on:click="beforeBlocked()">
              {{ statusLabel }}
            </CButton>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import {Candidates} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import VueNotifications from "vue-notifications";
import ProfilerDetail from "/src/views/ProfilerDetail.vue";
import EntityTimeStamp from "/src/components/EntityTimeStamp";
import store from "../../../store/store";

Vue.use(VueNotifications);
Vue.use(VueForm);

export default {
  name: "DetailItem",
  mixins: [Mixin],
  components: {
    ProfilerDetail,
    EntityTimeStamp,
  },
  data() {
    return {
      statusLabel: "Block",
      statusColor: "danger",
      selectedColumns: [],
      iAmUser: "",
      userId: "",
      listUrl: "",
      list: [],
      statusOption: [
        {value: "1", label: "Active"},
        {value: "0", label: "InActive"},
        {value: "2", label: "Block"}
      ],
      experienceList: [],
      commissionTypeList: [],
      workTypeList: [],
      availabilityList: [],
      currencyList: [],
      jobTypeList: [],
      json_data: [],
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      err_msg: "",
      largeModal: false,
      submitted: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      candidateData: [],
      requirement: [],
      worktype: [],
      experience: '',
      activePage: 1,
      module: Candidates,
      recruitments: {
        registeredType: "",
        firstName: "",
        company: "",
      },
      post: {
        reason: "",
        isActive: "",
      }
    }
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    store.commit("showLoader", false);
    axios.get('candidates/view/' + id).then((response) => {
      if (response) {
        let responseData = response.data.data;
        self.candidateData = responseData;
        self.experience = responseData.experience?.title ?? "";
        self.worktype = responseData.worktype?.title ?? "";
        self.requirement = responseData.availability.title;
        self.post.isStatus = responseData.isActiveStatus ?? '';
        self.isStatus = responseData.isActiveStatus ?? '';
        self.post.isActive = responseData.isActive;
        if (self.post.isStatus === "Active") {
          self.post.isStatus = 'Open';
          self.statusLabel = this.getStatusLabel(2);
          self.statusId = "2";
          self.statusColor = "danger";
        } else {
          self.statusId = "1";
          self.statusLabel = this.getStatusLabel(1);
          self.statusColor = "success";
        }
      } else {
        self.data = [];
      }
    });
  },
  methods: {
    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },
    beforeBlocked() {
      let self = this;
      self.post.reason = "";
      if (self.post.isActive === 1) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },
    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.post.isActive === 1) {
        if (self.post.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;

            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.post.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }
              axios
                  .post(this.statusUrlWeb(this.module, id), postData)
                  .then(function (response) {
                    if (response.data.code === 200) {
                      self.post.isStatus = status;
                      self.statusLabel = button;
                      self.largeModal = false;
                      self.submitted = false; //Enable Button
                      self.$router.go();
                    } else {
                      self.err_msg = response.data.message;
                      self.dismissCountDown = 10;
                    }
                  })
                  .catch(function () {
                    self.submitted = false; //Enable Button
                  });
            }, 500);
          }
        });
      } else {
        let self = this;
        const id = this.$route.params.id;
        const postData = {
          status: statusId,
          reason: null,
        };
        let status, button;
        if (self.statusId === "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
            .post(this.statusUrlWeb(this.module, id), postData)
            .then(function (response) {
              if (response.data.code === 200) {
                self.post.isStatus = status;
                self.statusLabel = button;
                self.largeModal = false;
                self.submitted = false; //Enable Button
                self.$router.go();
              } else {
                self.err_msg = response.data.message;
                self.dismissCountDown = 10;
              }
            })
            .catch(function () {
              self.submitted = false; //Enable Button
            });
      }
    },
  },
};
</script>
